import { apiFetchV2 } from '@m/utils/http';

export interface FlagOptions {
  enterpriseId?: number | null;
  siteId?: number | null;
  siteUuid?: string | null;
}

export interface SetFeatureFlagSettingOptions {
  enabled?: boolean;
  enterprises?: number[];
  sites?: number[];
  siteUuids?: string[];
}

export const FeatureFlagService = {
  archiveFeatureFlag: (name: string) =>
    apiFetchV2<undefined>(`/admin/feature/${name}`, { method: 'DELETE' }),
  createFeatureFlag: (name: string, { enabled, sites }: SetFeatureFlagSettingOptions = {}) =>
    apiFetchV2<SetFeatureFlagSettingOptions>(`/admin/feature/${name}`, {
      method: 'POST',
      body: sites ? { sites } : { enabled },
    }),
  getAdminFeatureFlagSetting: (name: string, options?: FlagOptions) =>
    apiFetchV2<SetFeatureFlagSettingOptions>(`/admin/feature/${name}`, {
      params: {
        siteId: options?.siteId,
        enterpriseId: options?.enterpriseId,
      },
    }),
  getAllFeatureFlags: () => apiFetchV2<{ flags: string[] }>('/admin/feature'),
  getCustomerFeatureFlag: (name: string, options?: FlagOptions) =>
    apiFetchV2<boolean>(`/customer/feature/${name}`, {
      params: {
        siteId: options?.siteId,
        enterpriseId: options?.enterpriseId,
        siteUuid: options?.siteUuid,
      },
    }),
  getSpecialistFeatureFlag: (name: string, options?: FlagOptions) =>
    apiFetchV2<boolean>(`/specialist/feature/${name}`, {
      params: {
        siteId: options?.siteId,
        enterpriseId: options?.enterpriseId,
      },
    }),
  setFeatureFlagSetting: (
    name: string,
    { enabled, sites, siteUuids, enterprises }: SetFeatureFlagSettingOptions,
  ) => {
    const hasSitesOrEnterprises =
      (sites && sites.length > 0) ||
      (siteUuids && siteUuids.length > 0) ||
      (enterprises && enterprises.length > 0);

    const body = hasSitesOrEnterprises
      ? {
          ...(sites && { sites }),
          ...(siteUuids && { siteUuids }),
          ...(enterprises && { enterprises }),
        }
      : { enabled };

    return apiFetchV2<SetFeatureFlagSettingOptions>(`/admin/feature/${name}`, {
      method: 'POST',
      body,
    });
  },
};
